import { Dispatch, SetStateAction, useEffect, useState } from 'react';

function getLocalStorageOrDefault<T>(key: string, initialValue?: T) {
    const stored = localStorage.getItem(key);
    if (stored === null) {
        return initialValue;
    }

    try {
        return JSON.parse(stored);
    } catch (e) {
        return initialValue;
    }
}

const useLocalStorage = <T>(
    key: string,
    initialValue?: T
): [T | undefined, Dispatch<SetStateAction<T | undefined>>] => {
    const [value, setValue] = useState(getLocalStorageOrDefault(key, initialValue));

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
};

export default useLocalStorage;
